export class AddressDto {

  public id!: string;
  public prime!: boolean;
  public label: string | undefined;
  public street: string | undefined;
  public houseNumber: string | undefined;
  public addressSuffix: string | undefined;
  public city: string | undefined;
  public zipCode: string | undefined;
  public postOfficeBox: string | undefined;
  public countryCode: string | undefined;
  // Distance in kilometers
  public distance: number | undefined;
  public externalId: string | undefined;
  public letterAddress: string | undefined;
  public completeAsLetter: boolean | undefined;

  constructor(init?: Partial<AddressDto> | undefined) {
    Object.assign(this, init);
  }
}
